import React from 'react';
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from 'react-tooltip'
const DealsTable = ({ tableData, onSort , loader }) => {

  const handleSort = (column) => {
    onSort(column);
  };



  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th className="partner" onClick={() => handleSort('supply_partner_name')}>Supply Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('demand_partner_name')}>Demand Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('country_name')}>Country <i className="fas fa-sort"></i></th>
              <th className="deal-name" onClick={() => handleSort('deal_name')}>Deal Name <i className="fas fa-sort"></i></th>
              <th className='margin' onClick={() => handleSort('revenue')}>Today's Adv Cost <i className="fas fa-sort"></i></th>
              <th className='margin' onClick={() => handleSort('revenue')}>Yesterday's Adv Cost <i className="fas fa-sort"></i></th>
            </tr>
          </thead>
          {!loader ?
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td className="wrap-string partner">{item?.supply_partner_name}</td>
                    <td className="wrap-string partner">{item?.supply_partner_name}</td>
                    <td className="wrap-string partner">{item?.country}</td>
                    <td className="wrap-string deal-name">{item?.deal_name}</td>
                    <td className="text-end partner">{item?.first_revenue}</td>
                    <td className="text-end partner">{item?.second_revenue}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
            :
            <div className={`loader ${loader ? 'show' : ''}`} >
              <label>
                <img src={loaderGif} />
              </label>
            </div>
          }
        </table>
      </div>
      <Tooltip id="my-tooltip-inline" place="top" style={{ backgroundColor: "rgb(182, 191, 183)", color: "#222" }} />
    </>
  );
};

export default DealsTable;
